/* eslint-disable react-hooks/exhaustive-deps */
import { Typography } from '@mui/material';
import { CloseSquareIcon, EditIcon, PlusIcon } from 'assets/icons';
import { IconLoadingButton, PrimaryButton, WhiteBgCard } from 'components';
import React from 'react';
import { useSelector } from 'react-redux';
import { useFormContext } from 'react-hook-form';
import { IBadge } from 'base/auth/interface';
import { selectBadges } from 'base/auth/selectors';
import { IUpdateProfileForm } from '../../interface';
import BadgeUploadModal from './components/upload-badge-modal';

const BadgeForm = () => {
  const {
    formState: { errors }, setValue, watch,
  } = useFormContext<IUpdateProfileForm>();

  const badges = watch('badges');
  const addedBadges = badges.filter((badge) => !badge.fromAdmin);

  const earnedbadges = useSelector(selectBadges);
  const badgesFromAdmin = React.useMemo(
    () => earnedbadges.filter((badge) => badge.fromAdmin),
    [earnedbadges],
  );

  const [openBadgeModal, setOpenBadgeModal] = React.useState(false);
  const [selectedBadge, setSelectedBadge] = React.useState<IBadge>({
    badgeTitle: '', badgeImgUrl: '', badgeDescription: '', fromAdmin: false,
  });
  const [selectedBadgeIndex, setSelectedBadgeIndex] = React.useState<number>(-1);

  const handleAddNewBadge = () => {
    setSelectedBadge({
      badgeTitle: '', badgeImgUrl: '', badgeDescription: '', fromAdmin: false,
    });
    setSelectedBadgeIndex(-1);
    setOpenBadgeModal(true);
  };

  const handleCancel = () => {
    setSelectedBadgeIndex(-1);
    setOpenBadgeModal(false);
  };

  const handleContinue = (badge: IBadge) => {
    if (badge.badgeTitle === '') {
      return;
    }
    console.log('handleContinue');
    if (selectedBadgeIndex >= 0) {
      const newAddedBadges = addedBadges.map((badgeItem, index: number) => {
        if (selectedBadgeIndex === index) {
          return badge;
        }
        return badgeItem;
      });
      setValue('badges', newAddedBadges);
    } else {
      setValue('badges', [
        ...addedBadges,
        badge,
      ]);
    }
    setSelectedBadgeIndex(-1);
    setOpenBadgeModal(false);
  };

  const handleRemove = (index: number) => {
    setValue('badges', [...(addedBadges.filter((item, i) => i !== index))]);
    setOpenBadgeModal(false);
  };

  const handleEdit = (badge: IBadge, index: number) => {
    setSelectedBadge(badge);
    setSelectedBadgeIndex(index);
    setOpenBadgeModal(true);
  };

  return (
    <>
      <div className="form-item">
        <Typography variant="h5" sx={{ mb: 2 }}>Badges and accreditations</Typography>
      </div>
      {addedBadges && addedBadges.length > 0 ? addedBadges?.map((badge, index) => (
        <WhiteBgCard border sx={{ mb: 2 }} key={`${badge.badgeTitle}-${Math.random()}`}>
          <div className="row">
            <div className="col-md-9 d-flex flex-column flex-md-row justify-content-start align-items-center text-center text-md-start">
              <img src={badge.badgeImgUrl} alt={badge.badgeTitle} className="img-" width="50" height="auto" />
              <div className="d-flex flex-column justify-content-center ms-0 ms-md-3">
                <Typography variant="h6">{badge.badgeTitle}</Typography>
                <Typography variant="body2">{badge.badgeDescription}</Typography>
              </div>
            </div>
            <div className="col-md-3 mt-2 mt-md-0 d-flex flex-row justify-content-between align-items-center">
              <IconLoadingButton
                startIcon={<EditIcon sx={{ color: 'primary.main' }} />}
                onClick={() => { handleEdit(badge, index); }}
              >
                Edit
              </IconLoadingButton>
              <IconLoadingButton
                startIcon={<CloseSquareIcon sx={{ color: 'primary.main' }} />}
                onClick={() => { handleRemove(index); }}
              >
                Remove
              </IconLoadingButton>
            </div>
          </div>
        </WhiteBgCard>
      )) : (
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
          There are no earned badges yet
        </Typography>
      )}
      <PrimaryButton
        startIcon={<PlusIcon sx={{ color: '#fff' }} />}
        onClick={handleAddNewBadge}
      >
        Add a new badge
      </PrimaryButton>
      <div className="form-item mt-4">
        <Typography variant="body2" sx={{ color: 'text.secondary', fontSize: '14px' }}>
          {badgesFromAdmin && badgesFromAdmin.length > 0 ? 'Badges received from admin' : 'There are no badges received from admin'}
        </Typography>
      </div>
      {badgesFromAdmin ? badgesFromAdmin?.map((badge, index) => (
        <WhiteBgCard border sx={{ mb: index === (badgesFromAdmin.length - 1) ? 0 : 2 }} key={`${badge.badgeTitle}-${Math.random()}`}>
          <div className="row">
            <div className="col-md-12 d-flex flex-column flex-md-row justify-content-start align-items-center text-center text-md-start">
              <img src={badge.badgeImgUrl} alt={badge.badgeTitle} className="img-" width="50" height="auto" />
              <div className="d-flex flex-column justify-content-center ms-0 ms-md-3">
                <Typography variant="h6">{badge.badgeTitle}</Typography>
                <Typography variant="body2">{badge.badgeDescription}</Typography>
              </div>
            </div>
          </div>
        </WhiteBgCard>
      )) : ''}
      <BadgeUploadModal
        open={openBadgeModal}
        onClose={handleCancel}
        onContinue={handleContinue}
        badge={selectedBadge}
      />
    </>
  );
};

export default BadgeForm;
